import React from 'react';

const ForumIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
  >
    <g fill="none">
      <path d="M0.1 13.4L0.1 13.4C0 11.6 0.4 9.9 1.4 8.3 2.2 6.7 3.4 5.3 5 4.1 6.5 2.9 8.4 1.9 10.6 1.2 12.6 0.5 14.9 0.2 17.4 0.2 20.5 0.2 23.4 0.8 26.2 1.9 28.9 3.1 31 4.8 32.7 6.8 33.5 7.9 34.1 9 34.6 9.9 34.9 10.9 35.1 12.1 35.1 13.4 35 15.9 34.3 18 33.1 19.6 31.7 21.3 29.6 22.6 26.7 23.7 26.4 24.8 26.3 25.7 26.3 26.3 26 26.8 25.8 27.6 25.6 28.4 25.1 29.3 24.7 30 24.3 30.6 23.7 31.2 23.1 31.8 22.3 32.5 21.3 33.2 20.3 33.9 19.1 34.5 18.7 34.8 18 35 17.1 35.1L15.4 35.3 15.6 35.3 14.6 35.3C16.8 33.8 18 32.5 18.2 31.4 18.9 30.1 19 29.1 18.7 28.3 18.6 27.5 18.2 26.9 17.5 26.6 17 26.2 16.3 26 15.3 25.9 14.5 26 12.9 25.9 10.6 25.5 8.6 24.8 6.8 23.8 5.1 22.6 3.5 21.4 2.3 20 1.4 18.4 0.5 16.9 0.1 15.2 0.1 13.4ZM7.7 13.6L26.9 13.6 26.8 11.1 7.8 11.1 7.7 13.6ZM7.9 18.6L26.9 18.6 27.1 15.9 7.8 15.9 7.9 18.6ZM7.9 9L27.1 9 26.9 6.3 8 6.3 7.9 9Z" />
    </g>
  </svg>
);

export default ForumIcon;
